import React, { Component } from "react";
import withRouter from "../helpers/withRouter";
import { emitter } from "../pages/home/context/event";
import introJs from "intro.js";
import { Link } from "react-router-dom";

interface InputBoxProps {
  onInputChange: (inputField: string) => void;
  updateParams: any;
  higherLevelProps: any;
  prompt: any;
  send: any;
  userPlan: string;
  haveAnyPrompt: boolean;
  sample_prompts: { sample_prompt: string; plan: string }[];
  book_talk_prompts: { sample_prompt: string; plan: string }[];
}

interface InputBoxState {
  userInput: string;
  plusToggle: string;
  isModalOpen: boolean;
  requiredTier: string;
}

interface tiersInNumbers {
  subscriber: number;
  patron: number;
  premium: number;
}

const tiersInNumbers: tiersInNumbers = {
  subscriber: 1,
  patron: 2,
  premium: 3,
};

class InputBox extends React.Component<InputBoxProps, InputBoxState> {
  state = {
    userInput: "",
    plusToggle: "",
    isModalOpen: false,
    requiredTier: "",
  };

  constructor(props: InputBoxProps) {
    super(props);
    if (this.props.prompt && this.props.prompt !== "") {
      this.state.userInput = this.props.prompt;
      if (this.props.send != null && this.props.send != "false") {
        setTimeout(() => {
          this.onSend();
          localStorage.setItem("pre_signup_sent", "true");
        }, 500);
      }
    }
  }

  componentDidMount(): void {
    // subscribe once on mount
    emitter.on("onSend", () => {
      // trigger the button
      this.onSend();
    });
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    // This code runs when the component updates (similar to useEffect with props or state dependencies)

    if (this.props.prompt !== prevProps.prompt) {
      this.setState({ userInput: this.props.prompt });
    }
  }

  handleKeyPress = (event: { key: string }) => {
    if (event.key === "Enter") {
      if (!localStorage.getItem("token"))
        return (window.location.href = `${process.env.REACT_APP_REST_API_URI}/login`);
      // The user pressed the "Enter" key, you can handle it here
      this.props.onInputChange(this.state.userInput);
      this.setState({ userInput: "" });
    }
  };

  userInput(userInput: string) {
    this.setState({ userInput });
  }

  openModal = (tier: string) => {
    this.setState({ isModalOpen: true, requiredTier: tier });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false, requiredTier: "" });
  };

  renderModal() {
    const { isModalOpen } = this.state;

    if (!isModalOpen) return null;
  }
  onSend() {
    if (!localStorage.getItem("token")) {
      console.log(this.props.prompt, "\n", this.state.userInput);
      console.log(this.props.prompt == this.state.userInput);
      if (
        this.state.userInput != localStorage.getItem("allowed_presignup_prompt")
      ) {
        return (window.location.href = `${process.env.REACT_APP_REST_API_URI}/login`);
      }
    }

    const prompt = this.props.sample_prompts.find(
      (value) => value.sample_prompt === this.state.userInput
    );
    const bookTalkPrompt = this.props.book_talk_prompts.find(
      (value) => value.sample_prompt === this.state.userInput
    );

    // 2) If *either* matched, pick the one that exists, and then use its `.plan`
    if (prompt || bookTalkPrompt) {
      // By this point, at least one is non‐undefined. Let’s pick the one that matched:
      const matchedPrompt = prompt || bookTalkPrompt!;
      // (we use `!` on bookTalkPrompt only because this line only runs if prompt is falsey, forcing
      //  bookTalkPrompt to be non‐undefined.)

      const userPlan =
        this.props.userPlan === "Basic"
          ? "subscriber"
          : this.props.userPlan === "Plus"
          ? "patron"
          : "premium";

      // Now it’s safe to do matchedPrompt.plan
      if (
        tiersInNumbers[matchedPrompt.plan as keyof typeof tiersInNumbers] >
          tiersInNumbers[userPlan as keyof typeof tiersInNumbers] &&
        localStorage.getItem("token")
      ) {
        emitter.emit("upgradePopup", matchedPrompt.plan);
        return;
      }
    }
    this.props.onInputChange(this.state.userInput);

    this.setState({ userInput: "" });
  }

  plusIcon() {
    const action: string = this.state.plusToggle == "action" ? "null" : "new";
    this.props.updateParams({
      action,
    });
    this.setState({
      plusToggle: this.state.plusToggle == "action" ? "null" : "action",
    });

    setTimeout(() => {
      const hasSeenTour = localStorage.getItem("hasSeenChatTourMobile");
      if (!hasSeenTour) {
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
          introJs()
            .setOptions({
              steps: [
                {
                  element: "#mobile-personality-mode",
                  intro: "Access chat prompts designed for fun conversations.",
                },
                {
                  element: "#mobile-booktalk-mode",
                  intro:
                    "Access bonus short stories, novel chapters, and chat with the characters about their book.",
                },
              ],
            })
            .start();
        }
        localStorage.setItem("hasSeenChatTourMobile", "true");
      }
    }, 1000);
  }

  render() {
    if (!this.props.haveAnyPrompt) return <></>;
    return (
      <>
        <div className="flex items-center input-box">
          <span className="hidden lg:block cursor-pointer opacity-90 add"></span>
          <span
            id="mobile-element-1"
            className="block lg:hidden cursor-pointer opacity-90 add"
            onClick={() => this.plusIcon()}
          >
            <img src="/assets/images/plus.svg" alt="" className="send-active" />
          </span>
          <input
            type="text"
            placeholder="Type a message here."
            value={this.state.userInput}
            onChange={(event) => this.userInput(event.target.value)}
            onKeyPress={this.handleKeyPress}
          />

          <span
            className="cursor-pointer opacity-90 send"
            onClick={() => this.onSend()}
          >
            <img src="/assets/images/send.svg" alt="" className="send-active" />
          </span>
        </div>
      </>
    );
  }
}

export default withRouter(InputBox);
